'use client'
import React from 'react'

export const AIIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4393_10389)">
      <path
        d="M6.25 4.75V7M5.125 5.875L7.375 5.875M6.25 13V14.125M6.25 14.125V15.25M6.25 14.125H5.125M6.25 14.125H7.375M10.75 5.5L11.2171 6.66785C11.7399 7.97466 12.7753 9.01014 14.0822 9.53286L15.25 10L13.686 10.782C12.6191 11.3154 11.7708 12.2032 11.2864 13.2932L10.75 14.5L10.2136 13.2932C9.72919 12.2032 8.8809 11.3154 7.814 10.782L6.25 10L7.41785 9.53286C8.72466 9.01014 9.76014 7.97466 10.2829 6.66785L10.75 5.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4393_10389">
        <rect fill="white" height="12" transform="translate(4 4)" width="12" />
      </clipPath>
    </defs>
  </svg>
)
